module.exports = __webpack_public_path__ + "img/p44.b2e55760.svg";